import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

interface Props {
  matterId: string;
  subsetId: string;
}

interface DownloadZipResponse {
  downloadUrl: string;
}

interface DownloadZipArgs {
  exportId: string;
  filename: string;
}

export const useDownloadDocumentZip = ({ matterId, subsetId }: Props) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const downloadDocumentZip = async ({ exportId, filename }: DownloadZipArgs): Promise<void> => {
    const url = new URL(`${APIBaseChronos}/api/matter/${matterId}/docs/download-zip/${subsetId}`);
    url.searchParams.set('exportId', exportId);
    url.searchParams.set('title', filename);

    const response = await fetch(url.toString(), fetchConfigGET);

    if (!response.ok) {
      throw new Error('Failed to get zip download URL');
    }

    const data: DownloadZipResponse = await response.json();

    const link = Object.assign(document.createElement('a'), {
      href: data.downloadUrl,
      download: `${filename}.zip`,
    });

    link.click();
  };

  const { mutate: downloadZip, isLoading: isDownloadingZip, error } = useMutation(downloadDocumentZip);

  return { downloadZip, isDownloadingZip, error };
};
